export const environment = {
  production: true,
  api_base: 'api/v1/',
  dataConfig: [],
  DEFAULT_TIMEZONE: 'Australia/Sydney',
  DEFAULT_LOCALE: 'en-AU', // Locale for luxon to show proper date format
};
